import { render, staticRenderFns } from "./SpcmCalenderAdd.vue?vue&type=template&id=65c94d56&scoped=true"
import script from "./SpcmCalenderAdd.vue?vue&type=script&lang=js"
export * from "./SpcmCalenderAdd.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SpcmCalenderAdd.vue?vue&type=style&index=1&id=65c94d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c94d56",
  null
  
)

export default component.exports